const getThreadId = (thread = {}) => {
  const threadId = String(thread?.id || thread?.threadId || '').trim();
  return threadId || null;
};

export default getThreadId;
